import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterModule
  ]
})
export class AppComponent {

  public loginComplete = false;

  constructor(
    public translateService: TranslateService
  ) {
    this.translateService.use(localStorage.getItem('lang') || 'en');
  }
}
